import { __require as n } from "./index.es21.js";
var o, h;
function f() {
  if (h) return o;
  h = 1, o = e;
  function e(t) {
    this._cbs = t || {}, this.events = [];
  }
  var r = n().EVENTS;
  return Object.keys(r).forEach(function(t) {
    if (r[t] === 0)
      t = "on" + t, e.prototype[t] = function() {
        this.events.push([t]), this._cbs[t] && this._cbs[t]();
      };
    else if (r[t] === 1)
      t = "on" + t, e.prototype[t] = function(s) {
        this.events.push([t, s]), this._cbs[t] && this._cbs[t](s);
      };
    else if (r[t] === 2)
      t = "on" + t, e.prototype[t] = function(s, i) {
        this.events.push([t, s, i]), this._cbs[t] && this._cbs[t](s, i);
      };
    else
      throw Error("wrong number of arguments");
  }), e.prototype.onreset = function() {
    this.events = [], this._cbs.onreset && this._cbs.onreset();
  }, e.prototype.restart = function() {
    this._cbs.onreset && this._cbs.onreset();
    for (var t = 0, s = this.events.length; t < s; t++)
      if (this._cbs[this.events[t][0]]) {
        var i = this.events[t].length;
        i === 1 ? this._cbs[this.events[t][0]]() : i === 2 ? this._cbs[this.events[t][0]](this.events[t][1]) : this._cbs[this.events[t][0]](
          this.events[t][1],
          this.events[t][2]
        );
      }
  }, o;
}
export {
  f as __require
};
//# sourceMappingURL=index.es32.js.map
